<template>
  <div class="content">
    <div class="home_part_1"></div>
    <div class="home_part_2">
      <div class="home_part_item">
        <div class="title">成本控制</div>
        <div class="des">量身定制，昂科科技为您控制底开发成本</div>
      </div>
      <div class="home_part_item">
        <div class="title">云服务器</div>
        <div class="des">量身定制，昂科科技为您控制底开发成本</div>
      </div>
      <div class="home_part_item">
        <div class="title">快速开发</div>
        <div class="des">量身定制，昂科科技为您控制底开发成本</div>
      </div>
      <div class="home_part_item">
        <div class="title">安全稳定</div>
        <div class="des">量身定制，昂科科技为您控制底开发成本</div>
      </div>
      <div class="home_part_item">
        <div class="title">专业设计</div>
        <div class="des">量身定制，昂科科技为您控制底开发成本</div>
      </div>
    </div>
    <div class="home_part_3">
      <div class="title">关于我们</div>
      <div class="smalltitle">全面人性化服务+优秀技术研发团队</div>
      <div class="img"></div>
      <div class="content_title">江西聚小宝科技有限公司</div>
      <div class="content_des">江西聚小宝科技有限公司是一家集软件自主研发、运营、维护及服务为一体的技术型公司。形成了内部管理体系、行政审批系统、电子商务管理系统、安全监测管理系统、微信二次开发管理系统等主要产品。并向客户提供专家团队的咨询服务、定制服务、运维服务。我们注重产品质量和优质服务，本着“务实创新，追求卓越”的核心价值观服务客户。</div>
    </div>
    <div class="home_part_4">
      <div class="title">为什么选择我们</div>
      <div class="smalltitle">全面人性化服务+优秀技术研发团队</div>
      <div class="item" style="top:279px;left:220px">
        <div class="img" style="background: url('/static/img/fz_item_2.png');"></div>
        <div class="title">更短开发周期</div>
        <div class="des">软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，
          它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是
          一种把管理软件和实施服务一体化打包的软件服务模式，它包括提
          供成熟的软件产品、优质的实施培训服务等。
        </div>
      </div>
      <div class="item" style="top:279px;left:980px">
        <div class="img" style="background: url('/static/img/fz_item_1.png');"></div>
        <div class="title">更低产开发成本</div>
        <div class="des">软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，
          它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是
          一种把管理软件和实施服务一体化打包的软件服务模式，它包括提
          供成熟的软件产品、优质的实施培训服务等。
        </div>
      </div>
      <div class="item" style="top:539px;left:220px">
        <div class="img" style="background: url('/static/img/fz_item_3.png');"></div>
        <div class="title">更高产品质量</div>
        <div class="des">软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，
          它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是
          一种把管理软件和实施服务一体化打包的软件服务模式，它包括提
          供成熟的软件产品、优质的实施培训服务等。
        </div>
      </div>
      <div class="item" style="top:539px;left:980px">
        <div class="img" style="background: url('/static/img/fz_item_4.png');"></div>
        <div class="title">更好安全性能</div>
        <div class="des">软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，
          它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是
          一种把管理软件和实施服务一体化打包的软件服务模式，它包括提
          供成熟的软件产品、优质的实施培训服务等。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
export default {
  name: "home",
  data() {
    return {
      planList: this.newsData.planList,
      classicProjectList: this.newsData.classicProjectList,
      homeNewsData: this.newsData.homeNewsData,
    };
  },

  methods: {
    toLink(link) {
      router.push(link || "/");
    },

    //移动到顶部
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },
  },
};
</script>

<style>
.content .banner {
  position: absolute;
  width: 100%;
  top: 40%;
  z-index: 8;
}

.home_part_1 {
  width: 100%;
  height: 920px;
  background: url("/static/img/fz_banner_img.png");
  background-repeat: no-repeat;
  position: relative;
}

.home_part_2 {
  width: 100%;
  height: 150px;
  background-color: #323646;
}

.home_part_2 .home_part_item {
  width: 20%;
  height: 150px;
  position: relative;
  float: left;
}

.home_part_2 .home_part_item .title {
  font-size: 24px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  position: absolute;
  top: 30px;
  left: 125px;
}

.home_part_2 .home_part_item .des {
  width: 212px;
  font-size: 18px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 76px;
  left: 125px;
  text-align: left;
}

.home_part_3 {
  width: 100%;
  height: 850px;
  background: #ffffff;
  position: relative;
}

.home_part_3 .title {
  font-size: 28px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  color: #333333;
  margin-top: 119px;
}

.home_part_3 .smalltitle {
  font-size: 24px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #999999;
  margin-top: 19px;
}

.home_part_3 .content_title {
  font-size: 24px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #323232;
  position: absolute;
  top: 339px;
  left: 261px;
}

.home_part_3 .content_des {
  width: 692px;
  font-size: 18px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #323232;
  line-height: 31px;
  position: absolute;
  top: 396px;
  left: 261px;
  text-align: left;
}

.home_part_3 .img {
  width: 600px;
  height: 420px;
  background: url("/static/img/fz_home_about_us.png");
  background-repeat: no-repeat;
  position: absolute;
  top: 289px;
  left: 1060px;
}

.home_part_4 {
  width: 100%;
  height: 829px;
  background: #f7f7f7;
  position: relative;
  padding-top: 119px;
}

.home_part_4 .title {
  font-size: 28px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  color: #333333;
}

.home_part_4 .smalltitle {
  font-size: 24px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #999999;
  margin-top: 19px;
}

.home_part_4 .item {
  width: 720px;
  height: 220px;
  background: #f3f2f2;
  border: 1px solid #e5e5e5;
  position: absolute;
}

.home_part_4 .item .img {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 51px;
  left: 24px;
}

.home_part_4 .item .title {
  font-size: 24px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  color: #232532;
  position: absolute;
  top: 51px;
  left: 124px;
}

.home_part_4 .item .des {
  width: 550px;
  font-size: 18px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #888888;
  line-height: 23px;
  position: absolute;
  top: 90px;
  text-align: left;
  left: 124px;
}
</style>



// WEBPACK FOOTER //
// home.vue?9cbaeee2